import * as React from 'react';
import BakeryDiningIcon from '@mui/icons-material/BakeryDining';
import { HomeMiniOutlined } from '@mui/icons-material';
import { alpha, FormControl, Box, Stack, Stepper, Step, Divider, Grid, InputAdornment, InputBase, InputLabel, Slider, styled, Typography, Card, Avatar, CardContent, useMediaQuery } from '@mui/material';
import { NumericFormat } from 'react-number-format';

function valuetext(value) {
    return `${value}`;
}

const marks = [
    { value: 1, },
    { value: 1.25, },
    { value: 1.50, },
    { value: 1.75, },
    { value: 2, },
    { value: 2.25, },
    { value: 2.50, },
    { value: 2.75, },
    { value: 3, },
    { value: 3.25, },
    { value: 3.50, },
    { value: 3.75, },
    { value: 4, },
    { value: 4.25, },
    { value: 4.50, },
    { value: 4.75, },
    { value: 5, },
];

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
    return (
        <NumericFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
        />
    );
}

const Steps = [
    { title: 'Step 1', des: 'Our clients can search for properties on any site, as all brokerages access the same MLS database and list the same properties. Our rebate program is available for any home listed by any company on any site. The Buyer Rebate amount can vary by state due to different regulations. When a lender is part of your transaction, their approval is essential for commission refunds. You will receive a commission disbursement, including your full rebate, to be credited at closing.' },
    { title: 'Step 2', des: 'Email realprop@gmail.com, call, text, or put it through your dashboard to schedule a property showing. Register Real Prop as your Buyer`s agent when visiting new construction sites to receive the full commission. We may need to accompany you on your first or second visit. Using other agents to show you properties is inappropriate, and this could impact your rebate. See FAQS.' },
    { title: 'Step 3', des: 'Contact us when you`re ready to make an offer via phone, text, or dashboard. Our experienced agents will assess the home`s value, evaluate the competition, and negotiate the best price and terms for Real Prop Full buyers. For Real Prop AI Assist, buyers have the option to evaluate the property themselves or utilize our Auto Estimator tool.' },
    { title: 'Step 4', des: 'Real Prop will draft and send the contract for electronic signing, then submit and negotiate the offer with the seller. We`ll also provide feedback on competition and allow you to adjust your offer if desired.' },
    { title: 'Step 5', des: 'Real Prop will handle inspection negotiations, repairs/credits, and other contingencies.' },
    { title: 'Step 6', des: 'Real Prop will keep track of timelines, review reports and handle contingencies. Our Experienced Brokers will help you with any questions you have 7 days a week from lending, price, terms, contingencies, escrow and post close questions and concerns' },
    { title: 'Step 7', des: 'Real Prop will handle all closing paperwork, pay a large buyer`s rebate, and ensure you receive the keys to your new home. All rebates should be disclosed to your lender.' },

];

const BootstrapInput = styled(InputBase)(({ theme, Matches }) => ({
    width: Matches ? '320px' : '450px',
    'label + &': {
        marginTop: theme.spacing(3),
        color: '#000'
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        textAlign: 'start',
        backgroundColor: theme.palette.mode === 'light' ? '#F4F3F2' : '#1A2027',
        border: '1px solid',
        borderColor: theme.palette.mode === 'light' ? '#F4F3F2' : '#2D3843',
        fontSize: 16,
        width: '100%',
        height: '30px',
        padding: '5px 12px',
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}));

export default function BuyCal(props) {
    const [value, setValue] = React.useState(3);
    const [value1, setValue1] = React.useState(1000000);
    const matches = useMediaQuery('(max-width:600px)');

    const handleChange = (event) => {
        setValue1(event.target.value);
    };
    const handleSliderChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleInputChange = (event) => {
        setValue(event.target.value === '' ? '' : Number(event.target.value));
    };

    const handleBlur = () => {
        if (value < 1) {
            setValue(1);
        } else if (value > 5) {
            setValue(5);
        }
    };

    const result = (value / 100) * value1;
    const commissionPercentage = 86.68;
    const finalAmount = Math.round((result - (commissionPercentage / 100) * result));
    const paid = Math.round(result - finalAmount)

    return (
        <>
            <Grid container spacing={1} sx={{ mt: matches ? '2em' : '3em', mb: matches ? '2em' : '4em' }} display='flex' flexDirection="column" justifyContent='center' alignItems="center">
                <Grid item xs={matches ? 12 : 6} display='flex' justifyContent='center'>
                    <FormControl variant="standard">
                        <InputLabel shrink htmlFor="bootstrap-input" sx={{ fontSize: '20px', color: '#000', fontWeight: 500 }}>
                            Enter the property price*
                        </InputLabel>
                        <BootstrapInput
                            value={value1}
                            onChange={handleChange}
                            id="bootstrap-input"
                            inputComponent={NumberFormatCustom}
                            startAdornment={<InputAdornment position="start" sx={{ fontWeight: 500 }}>$</InputAdornment>}
                            Matches={matches}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={matches ? 12 : 6} display='flex' justifyContent='center' sx={{ mt: '2em' }}>
                    <FormControl variant="standard">
                        <InputLabel shrink htmlFor="bootstrap-input" sx={{ fontSize: '20px', color: '#000', fontWeight: 500 }}>
                            Commission Offered by the Seller
                        </InputLabel>
                        <BootstrapInput
                            value={value}
                            onChange={handleInputChange}
                            onBlur={handleBlur}
                            defaultValue="3"
                            inputProps={{
                                step: 0.5,
                                min: 1,
                                max: 5,
                                type: 'number',
                                'aria-labelledby': 'input-slider',
                            }}
                            Matches={matches}
                        />
                        <Slider
                            aria-label="Temperature"
                            value={value}
                            onChange={handleSliderChange}
                            getAriaValueText={valuetext}
                            valueLabelDisplay="auto"
                            marks={marks}
                            step={0.25}
                            min={1}
                            max={5}
                            sx={{
                                width: 'auto',
                                color: '#978A7D'
                            }}

                        />
                    </FormControl>
                </Grid>
            </Grid>
            {/* <Grid container spacing={1} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: '3em', p: '0em 6em' }}>
                <Grid item xs >
                    <Card
                        data-resizable
                        color='none'
                        size='md'
                        sx={{
                            textAlign: 'center',
                            alignItems: 'center',
                            width: 343,
                            // to make the demo resizable
                            overflow: 'auto',
                            resize: 'horizontal',
                            '--icon-size': '100px',
                        }}
                    >
                        <CardOverflow variant="solid" color="danger">
                            <AspectRatio
                                variant="outlined"
                                color="danger"
                                ratio="1"
                                sx={{
                                    m: 'auto',
                                    transform: 'translateY(50%)',
                                    borderRadius: '50%',
                                    width: 'var(--icon-size)',
                                    boxShadow: 'sm',
                                    bgcolor: 'background.surface',
                                    position: 'relative',
                                }}
                            >
                                <Typography sx={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>
                                    <NumericFormat value={result} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                </Typography>
                            </AspectRatio>
                        </CardOverflow>
                        <CardContent sx={{ maxWidth: '40ch', mt: '3em' }}>
                            <Typography variant="body1" gutterBottom sx={{ color: 'red', }}>Commission offered by Seller</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                    <Typography variant="h3" > - </Typography>
                </Grid>
                <Grid item xs >
                    <Card
                        data-resizable
                        color='none'
                        size='md'
                        sx={{
                            textAlign: 'center',
                            alignItems: 'center',
                            width: 343,
                            // to make the demo resizable
                            overflow: 'auto',
                            resize: 'horizontal',
                            '--icon-size': '100px',
                        }}
                    >
                        <CardOverflow variant="solid" color="primary">
                            <AspectRatio
                                variant="outlined"
                                color="primary"
                                ratio="1"
                                sx={{
                                    m: 'auto',
                                    transform: 'translateY(50%)',
                                    borderRadius: '50%',
                                    width: 'var(--icon-size)',
                                    boxShadow: 'sm',
                                    bgcolor: 'background.surface',
                                    position: 'relative',
                                }}
                            >
                                <Typography sx={{ fontSize: '18px', color: '#000', fontWeight: 500 }}>
                                    <NumericFormat value={finalAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                </Typography>
                            </AspectRatio>
                        </CardOverflow>
                        <CardContent sx={{ maxWidth: '40ch', mt: '3em' }}>
                            <Typography color="primary" variant="body1" gutterBottom >Share</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                    <Typography variant="h3" >=</Typography>
                </Grid>
                <Grid item xs >
                    <Card
                        data-resizable
                        color='none'
                        size='md'
                        sx={{
                            textAlign: 'center',
                            alignItems: 'center',
                            width: 343,
                            // to make the demo resizable
                            overflow: 'auto',
                            resize: 'horizontal',
                            '--icon-size': '100px',
                        }}
                    >
                        <CardOverflow variant="solid" color="success">
                            <AspectRatio
                                variant="outlined"
                                color="success"
                                ratio="1"
                                sx={{
                                    m: 'auto',
                                    transform: 'translateY(50%)',
                                    borderRadius: '50%',
                                    width: 'var(--icon-size)',
                                    boxShadow: 'sm',
                                    bgcolor: 'background.surface',
                                    position: 'relative',
                                }}
                            >
                                <Typography sx={{ fontSize: '18px', color: '#000', fontWeight: 500 }} >
                                    <NumericFormat value={paid} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                </Typography>
                            </AspectRatio>
                        </CardOverflow>
                        <CardContent sx={{ maxWidth: '40ch', mt: '3em' }}>
                            <Typography variant="body1" color="success" gutterBottom sx={{ color: '', }}>Get paid instead of agents</Typography>
                        </CardContent>
                    </Card>

                </Grid>
                <Divider orientation="horizontal" sx={{ mb: '3em' }} />
                <Box sx={{ mt: '3em', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} ref={props.section1Ref}>
                    <Stack spacing={0} display="flex" alignItems="center" sx={{ m: '2em 0em' }}>
                        <Typography
                            sx={{ fontSize: '20px', fontWeight: 600, color: '#303f5b' }}
                        >
                            Thousands of Homes Purchased & Millions of $ Rebated
                        </Typography>
                        <Typography
                            sx={{ fontSize: '34px', fontWeight: 500, color: '#000' }}
                        >
                            Frictionless Process
                        </Typography>
                    </Stack>
                    <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'start', mt: '1em', }}>
                        {
                            Steps.map((item) => {
                                return (
                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                        <Card
                                            variant="outlined"
                                            sx={{ width: 'auto', maxWidth: '100%', gap: 1, height: '250px' }}
                                        >
                                            <Typography variant="body1" gutterBottom textAlign="start">
                                                {item.title}
                                            </Typography>
                                            <Divider />
                                            <Box >
                                                <Typography sx={{ fontSize: '13px' }} gutterBottom textAlign="start">
                                                    {item.des}
                                                </Typography>
                                            </Box>
                                        </Card>
                                    </Grid>
                                )
                            })
                        }
                        <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}></Grid>
                    </Grid>
                </Box>

            </Grid> */}
            <Grid container spacing={1} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: '3em', p: matches ? '0em 2em' : '0em 6em' }}>
                {
                    matches ?
                        <>
                            <Grid item xs={12}>
                                <Card
                                    sx={{
                                        textAlign: 'center',
                                        alignItems: 'center',
                                        width: 'auto',
                                        // to make the demo resizable
                                        overflow: 'auto',
                                        resize: 'horizontal',
                                        '--icon-size': '100px',
                                    }}
                                >
                                    <Card elevation={0} sx={{ height: '100px', bgcolor: '#978A7D', borderRadius: 0 }}>
                                        <Stack display="flex" justifyContent="center" alignItems="center" sx={{ mt: '2em' }}>
                                            <Avatar
                                                sx={{
                                                    position: 'absolute',
                                                    p: '3em',
                                                    m: 'auto',
                                                    transform: 'translateY(50%)',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#F4F3F2'
                                                }}
                                            >
                                                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                                    <NumericFormat value={result} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                </Typography>
                                            </Avatar>
                                        </Stack>

                                    </Card>
                                    <CardContent sx={{ maxWidth: '40ch', mt: '3em' }}>
                                        <Typography variant="body1" gutterBottom >Commission offered by Seller</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                <Typography variant="h4" > - </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Card
                                    sx={{
                                        textAlign: 'center',
                                        alignItems: 'center',
                                        width: 'auto',
                                        // to make the demo resizable
                                        overflow: 'auto',
                                        resize: 'horizontal',
                                        '--icon-size': '100px',
                                    }}
                                >
                                    <Card elevation={0} sx={{ height: '100px', bgcolor: '#978A7D', borderRadius: 0 }}>
                                        <Stack display="flex" justifyContent="center" alignItems="center" sx={{ mt: '2em' }}>
                                            <Avatar
                                                sx={{
                                                    position: 'absolute',
                                                    p: '3em',
                                                    m: 'auto',
                                                    transform: 'translateY(50%)',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#F4F3F2'
                                                }}
                                            >
                                                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                                    <NumericFormat value={finalAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                </Typography>
                                            </Avatar>
                                        </Stack>

                                    </Card>
                                    <CardContent sx={{ maxWidth: '40ch', mt: '3em' }}>
                                        <Typography variant="body1" gutterBottom >Share</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                <Typography variant="h4" > = </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Card
                                    sx={{
                                        textAlign: 'center',
                                        alignItems: 'center',
                                        width:'auto',
                                        // to make the demo resizable
                                        overflow: 'auto',
                                        resize: 'horizontal',
                                        '--icon-size': '100px',
                                    }}
                                >
                                    <Card elevation={0} sx={{ height: '100px', bgcolor: '#978A7D', borderRadius: 0 }}>
                                        <Stack display="flex" justifyContent="center" alignItems="center" sx={{ mt: '2em' }}>
                                            <Avatar
                                                sx={{
                                                    position: 'absolute',
                                                    p: '3em',
                                                    m: 'auto',
                                                    transform: 'translateY(50%)',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#F4F3F2'
                                                }}
                                            >
                                                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                                    <NumericFormat value={paid} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                </Typography>
                                            </Avatar>
                                        </Stack>

                                    </Card>
                                    <CardContent sx={{ maxWidth: '40ch', mt: '3em' }}>
                                        <Typography variant="body1" gutterBottom >Get paid instead of agents</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </>
                        :
                        <>
                            <Grid item xs>
                                <Card
                                    sx={{
                                        textAlign: 'center',
                                        alignItems: 'center',
                                        width:343,
                                        // to make the demo resizable
                                        overflow: 'auto',
                                        resize: 'horizontal',
                                        '--icon-size': '100px',
                                    }}
                                >
                                    <Card elevation={0} sx={{ height: '100px', bgcolor: '#978A7D', borderRadius: 0 }}>
                                        <Stack display="flex" justifyContent="center" alignItems="center" sx={{ mt: '2em' }}>
                                            <Avatar
                                                sx={{
                                                    position: 'absolute',
                                                    p: '3em',
                                                    m: 'auto',
                                                    transform: 'translateY(50%)',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#F4F3F2'
                                                }}
                                            >
                                                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                                    <NumericFormat value={result} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                </Typography>
                                            </Avatar>
                                        </Stack>

                                    </Card>
                                    <CardContent sx={{ maxWidth: '40ch', mt: '3em' }}>
                                        <Typography variant="body1" gutterBottom >Commission offered by Seller</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                <Typography variant="h4" > - </Typography>
                            </Grid>
                            <Grid item xs>
                                <Card
                                    sx={{
                                        textAlign: 'center',
                                        alignItems: 'center',
                                        width: 343,
                                        // to make the demo resizable
                                        overflow: 'auto',
                                        resize: 'horizontal',
                                        '--icon-size': '100px',
                                    }}
                                >
                                    <Card elevation={0} sx={{ height: '100px', bgcolor: '#978A7D', borderRadius: 0 }}>
                                        <Stack display="flex" justifyContent="center" alignItems="center" sx={{ mt: '2em' }}>
                                            <Avatar
                                                sx={{
                                                    position: 'absolute',
                                                    p: '3em',
                                                    m: 'auto',
                                                    transform: 'translateY(50%)',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#F4F3F2'
                                                }}
                                            >
                                                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                                    <NumericFormat value={finalAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                </Typography>
                                            </Avatar>
                                        </Stack>

                                    </Card>
                                    <CardContent sx={{ maxWidth: '40ch', mt: '3em' }}>
                                        <Typography variant="body1" gutterBottom >Share</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                <Typography variant="h4" > = </Typography>
                            </Grid>
                            <Grid item xs>
                                <Card
                                    sx={{
                                        textAlign: 'center',
                                        alignItems: 'center',
                                        width: 343,
                                        // to make the demo resizable
                                        overflow: 'auto',
                                        resize: 'horizontal',
                                        '--icon-size': '100px',
                                    }}
                                >
                                    <Card elevation={0} sx={{ height: '100px', bgcolor: '#978A7D', borderRadius: 0 }}>
                                        <Stack display="flex" justifyContent="center" alignItems="center" sx={{ mt: '2em' }}>
                                            <Avatar
                                                sx={{
                                                    position: 'absolute',
                                                    p: '3em',
                                                    m: 'auto',
                                                    transform: 'translateY(50%)',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#F4F3F2'
                                                }}
                                            >
                                                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                                    <NumericFormat value={paid} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                </Typography>
                                            </Avatar>
                                        </Stack>

                                    </Card>
                                    <CardContent sx={{ maxWidth: '40ch', mt: '3em' }}>
                                        <Typography variant="body1" gutterBottom >Get paid instead of agents</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </>
                }
                <Divider orientation="horizontal" sx={{ mb: matches ? '1em':'3em' }} />
                <Box sx={{ mt: '3em', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} ref={props.section1Ref}>
                    <Stack spacing={0} display="flex" alignItems="center" sx={{ m: matches ? '1em 0' : '2em 0em' }}>
                        <Typography variant="h5" sx={{
                            fontSize: matches ? '16px' : null,
                            fontWeight: matches ? 500 : null,
                            letterSpacing: '-0.03em',
                        }}>
                            Thousands of Homes Purchased & Millions of $ Rebated
                        </Typography>
                        <Typography variant='h4'
                            sx={{
                                textAlign: 'start',
                                mt: matches ? 0 : '10px',
                                fontSize: matches ? '22px' : null,
                                fontWeight: matches ? 600 : null,
                                letterSpacing: '-0.03em',
                            }}>
                            Frictionless Process
                        </Typography>
                    </Stack>
                    <Grid container spacing={2} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', mt: '1em', }}>
                        {
                            Steps.map((item) => {
                                return (
                                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                        <Card
                                            variant="outlined"
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                width: matches ? 'auto' : '80vh',
                                                maxWidth: '100%',
                                                p: 0,
                                                height:'auto' ,
                                                backgroundColor: '#F4F3F2',
                                                borderRadius: '8px',
                                                borderColor: '#d6e1e8'
                                            }}
                                        >
                                            <Typography variant="h7" gutterBottom textAlign="start" sx={{ ml: '1em', pt: '10px', fontWeight: 600 }}>
                                                {item.title}
                                            </Typography>
                                            <Divider />
                                            <Box sx={{ p: '1em' }}>
                                                <Typography sx={{ fontSize: '13px' }} gutterBottom textAlign="start">
                                                    {item.des}
                                                </Typography>
                                            </Box>
                                        </Card>
                                    </Grid>
                                )
                            })
                        }
                        <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}></Grid>
                    </Grid>
                </Box>

            </Grid>

        </>
    );
}
